"use strict";
const { object, string } = require('../utils/modifiedYup');
exports.variableSchema = object().shape({
    variableId: string().required(),
    variableType: string()
        .oneOf(['string', 'date', 'number', 'recipient', 'array-of-string'])
        .required(),
    type: string()
        .oneOf([
        'FormTextInput',
        'FormTextArea',
        'FormDatePicker',
        'FormRadioList',
        'FormCheckboxList',
        'FormDropdown',
        'FormNumericSlider',
        'FormYesNoButtons',
        'Recipient',
        'PhoneNumber',
        'EmailAddress',
        'Text',
        'Number',
        'Date',
        // TODO: Revisit
        // content builder types
        'form-text-input',
        'form-text-area',
        'form-radio-list',
        'form-checkbox-list',
        'form-date-input',
        'form-dropdown',
        'form-yes-no-buttons',
        'form-ratings',
        'form-slider',
        'form-location',
    ])
        .required(),
});
//# sourceMappingURL=variableSchema.js.map